import PredefinedSetProperty from "../properties/basic/PredefinedSetProperty";
import {DrillType} from "../../util/GCodeSettingBuilder";
import React from "react";
import {Classes} from "../properties/basic/Basics";

type DrillTypeOption = {
    name: string
    type: DrillType
}

const options: Array<DrillTypeOption> = [
    {
        name: "Drill",
        type: DrillType.DRILL
    },
    {
        name: "Milling",
        type: DrillType.MILLING
    }
]

type Properties = Classes & {
    drillType: DrillType
    onChange: (newValue: DrillType) => void
}

function DrillTypeSelector(props: Properties) {
    function handleDrillTypeChange(selectedDrillTypeOption: DrillTypeOption) {
        if (props.onChange != null) {
            props.onChange(selectedDrillTypeOption.type)
        }
    }

    return <>
        <PredefinedSetProperty
            label={"Drill type"}
            val={options[props.drillType]}
            options={options}
            onChange={handleDrillTypeChange}
            optionLabel={"name"}
            inputAdditionalClassName={props.inputAdditionalClassName}
            labelAdditionalClassName={props.labelAdditionalClassName}
        />
    </>
}

export default DrillTypeSelector